import React from 'react';

const SubscriptionInfo = ({ trialEndDate, isAnnual, price }) => {
    if (!trialEndDate || !new Date(trialEndDate)) {
        return null;
    }

    return (
        <div className="text-center py-6">
            <p className="text-gray-600 text-sm mb-1">
                You won&apos;t be charged till <span className="text-gray-600 font-medium">
                    {new Date(trialEndDate * 1000).toLocaleDateString("en-US", {
                        month: "long",
                        day: "numeric",
                        year: "numeric"
                    })}
                </span>.
            </p>
            <p className="text-gray-600 text-sm mb-3">
                Cancel anytime before that date.
            </p>
            <p className="text-gray-500 text-xs">
                After your free trial, the {isAnnual ? "annual" : "monthly"} subscription
                is ${price} and automatically renews every {isAnnual ? "year" : "month"} until you cancel.
            </p>
        </div>
    );
};

export default SubscriptionInfo; 